import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M13 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0","key":"svg-1"}],["path",{"d":"M8 12h2","key":"svg-2"}],["path",{"d":"M10 9h-2v6","key":"svg-3"}]]

const IconSquareF0 = createReactComponent('outline', 'square-f0', 'SquareF0', __iconNode);

export default IconSquareF0;